import { render, staticRenderFns } from "./appraise_edit.vue?vue&type=template&id=122e150c&scoped=true"
import script from "./appraise_edit.vue?vue&type=script&lang=js"
export * from "./appraise_edit.vue?vue&type=script&lang=js"
import style0 from "./appraise_edit.vue?vue&type=style&index=0&id=122e150c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e150c",
  null
  
)

export default component.exports